export const facebook = '1774769045895170'
export const google = 'UA-118622166-1'
export const gtm = 'GTM-T64SPLQL'
export const hotjar = '872708'
export const metrilo = '1c8d61d38a32cebb'

export const isDev = () => (
	( typeof location !== 'undefined' && location.hostname === 'localhost' ) ||
	process.env.NODE_ENV !== 'production'
)
